import { usePage } from "@inertiajs/react";

import type { SharedProps, UserOrigin } from "@/types";

export const GENDERED_TEXT = {
  usuarios: { los_tilos: "Usuarias", la_cuesta: "Usuarios" },
  usuariosEmptyState: {
    los_tilos: "No hay usuarias registradas.",
    la_cuesta: "No hay usuarios registrados.",
  },
  administradoraCasa: {
    los_tilos: "Administradora",
    la_cuesta: "Administrador",
  },
  isAdmin: { los_tilos: "Administradora", la_cuesta: "Administrador" },
  isHouseManager: {
    los_tilos: "Administradora de Casa",
    la_cuesta: "Administrador de Casa",
  },
  isHouseMaster: {
    los_tilos: "Administradora de todas las casas",
    la_cuesta: "Administrador de todas las casas",
  },
  isDirector: {
    los_tilos: "Encargada Actividad",
    la_cuesta: "Encargado Actividad",
  },
  isStudent: { los_tilos: "Alumna", la_cuesta: "Alumno" },
  eliminarUsuario: {
    los_tilos: "Eliminar usuaria",
    la_cuesta: "Eliminar usuario",
  },
  eliminarUsuarioMensaje: {
    los_tilos: "¿Estás segura? Se eliminará a la usuaria",
    la_cuesta: "¿Estás seguro? Se eliminará al usuario",
  },
  isSubscriber: { los_tilos: "Inscriptora", la_cuesta: "Inscriptor" },
  isCenterDirector: {
    los_tilos: "Directora de Centro",
    la_cuesta: "Director de Centro",
  },
  exportarInscritas: {
    los_tilos: "Exportar excel",
    la_cuesta: "Exportar excel",
  },
  cerrarCursoMensaje: {
    los_tilos:
      "¿Estás segura? No se podrán realizar más inscripciones, pagos ni cambios en la lista de espera.",
    la_cuesta:
      "¿Estás seguro? No se podrán realizar más inscripciones, pagos ni cambios en la lista de espera.",
  },
} as const satisfies Record<string, Record<UserOrigin, string>>;

export type GenderedTextKey = keyof typeof GENDERED_TEXT;

export function gendered(
  key: GenderedTextKey,
  origin: UserOrigin | null | undefined,
): string {
  return GENDERED_TEXT[key][origin === "la_cuesta" ? "la_cuesta" : "los_tilos"];
}

export function useGenderedText(): (key: GenderedTextKey) => string {
  const { currentUser } = usePage<SharedProps>().props;
  return (key) => gendered(key, currentUser?.origin);
}
